'use client';

import { IcArrowDown, Sheet, SheetTrigger, Typography } from '@musinsa/mds';
import { useQuery } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { type FC, useState } from 'react';
import { usePreventBodyScroll } from '../../../../common/hooks/usePreventBodyScroll';
import { getCurrentTime } from '../../../../common/utils';
import { profileFactory } from '../../../../query-factory/profile.factory';
import { useSalesRankingFilter } from '../SalesRankingFilterProvider';
import { type MonthOptionType, toMonthOption } from './utils';

const DynamicMonthOptionsSheet = dynamic(
  () =>
    import('./MonthOptionsSheet').then((mod) => ({
      default: mod.MonthOptionsSheet,
    })),
  {
    ssr: false,
  },
);

export const SalesRankingMonthSelector: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: userInfo } = useQuery({
    ...profileFactory.userInfo,
  });
  usePreventBodyScroll({ open: isOpen });

  const { filter, setFilter } = useSalesRankingFilter();

  const handleChange = (nextValue: MonthOptionType) => {
    setFilter({ ...filter, month: nextValue });
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const now = getCurrentTime();

  return (
    <Sheet direction="bottom" open={isOpen} onOpenChange={setIsOpen}>
      <Typography variant="title18pxMed" className="text-black" asChild>
        <h2 className="px-4 py-3">
          <SheetTrigger asChild>
            <button type="button" className="flex items-center space-x-0.5">
              <span>{filter.month.label}</span>
              <IcArrowDown width={20} height={20} />
            </button>
          </SheetTrigger>
        </h2>
      </Typography>
      <DynamicMonthOptionsSheet
        defaultValue={toMonthOption(now)}
        range={[now, userInfo?.registeredDate]}
        onChange={handleChange}
        onClose={handleClose}
      />
    </Sheet>
  );
};
